import React, { Fragment } from 'react';
import { Route, Router, Routes } from 'react-router-dom';

import { PageNotFound, NoPermission, UnAuthorized, Profile, MyProjectCard, MyProjectDetailCard, ChangePassword, Teams, UserDashboard, Role, Permission, RolePermission, UserManager, Team } from '../pages/extentions';
import {
    Home, Dashboard, Timesheets, Expenses, Calendar, Timeline, Approvals, NotificationBar, CreateTimesheet, Settings,
    Attendance, MyAction, Report, Training, Trf,
    Leaves, TrainingDashboard, OpenForm, Support, NewTicket, TicketDetails,
    AgentQueue, AgentWork, AdminDashboard
    // NewAbsenceRequest,
} from '../pages'
import Master from '../pages/master/master';
import { getFilteredMenus } from '../common/helpers/permissions';
import {
    ATTENDANCE_MENU_VIEW, TIMESHEET_MENU_VIEW, EXPENSES_MENU_VIEW,
    LEAVES_MENU_VIEW,
    USER_MAINTENANCE_MENU_VIEW,
    PAYSLIP_MENU_VIEW, MYTEAMS_MENU_VIEW, MYPROJECT_MENU_VIEW, CALENDAR_MENU_VIEW,
    MASTER_MENU_VIEW, SETTING_MENU_VIEW, REPORT_MENU_VIEW, DOCUMENT_APIDOC,
    TRAINING_MENU_VIEW,
} from '../config/permissions';
import Travels from '../pages/travel/travel';
import TravelDetails from '../pages/travel/traveldetails';
import PassportDetails from '../pages/travel/passportdetails';
import InsuranceDetails from '../pages/travel/insurancedetails';
import TravelDataTable from '../pages/travel/travel-datatable';
import TrfApproval from '../pages/training/trf-approval';
import TrainingValidation from '../pages/training/training-validation';
import TrainingEffectivenessReport from '../pages/training/training-effectiveness-report';
import TrainingEffectivenessFeedback from '../pages/training/training-effectiveness-feedback';
import Payslip from '../pages/payslip/payslip';
import Help from '../pages/dashboard/help';

// import {Support, NewTicket, TicketDetails, AgentQueue, AgentWork, AdminDashboard} from '../pages/support';

const subRouteArray = [
    // { path: 'new', component: <EditPsaps module='new' />, parent: 'psaps' },
]

const routeArray = [
    { id: 'root', path: '/', component: <Home />, items: [] },
    { id: 'home', path: '/home', component: <Home />, permissions: null },
    { id: 'dashboard', path: '/dashboard', component: <Dashboard /> },
    { id: 'profile', path: '/profile', component: <Profile /> },
    { id: 'change-password', path: '/change-password', component: <ChangePassword /> },
    { id: 'teams', path: '/teams', component: <Teams /> },
    { id: 'timesheets', path: '/timesheets', component: <Timesheets />, permissions: [TIMESHEET_MENU_VIEW] },
    { id: 'create-timesheet', path: '/create-timesheet', component: <CreateTimesheet />, permissions: [TIMESHEET_MENU_VIEW] },
    { id: 'leaves', path: '/leaves', component: <Leaves />, permissions: [LEAVES_MENU_VIEW] },
    { id: 'new-absence', path: '/leaves/new-absence', component: <Leaves />, permissions: [LEAVES_MENU_VIEW] },
    // { id: 'new-absence', path: '/leaves/new-absence', component: <NewAbsenceRequest />, permissions: [LEAVES_MENU_VIEW] },
    { id: 'expenses', path: '/expenses', component: <Expenses />, permissions: [EXPENSES_MENU_VIEW] },
    { id: 'payslip', path: '/payslip', component: <Payslip />, permissions: [LEAVES_MENU_VIEW] },
    { id: 'payslip', path: '/payslip', component: <Payslip />, permissions: [PAYSLIP_MENU_VIEW] },
    { id: 'calendar', path: '/calendar', component: <Calendar />, permissions: [CALENDAR_MENU_VIEW] },
    { id: 'settings', path: '/settings', component: <Settings />, permissions: [SETTING_MENU_VIEW] },
    { id: 'master', path: '/master', component: <Master />, permissions: [MASTER_MENU_VIEW] },
    { id: 'user-maintenance', path: '/user-maintenance', component: <UserDashboard />, permissions: [USER_MAINTENANCE_MENU_VIEW] },
    { id: 'user-maintenance-user', path: '/user-maintenance/user', component: <userMaintenance />, permissions: [USER_MAINTENANCE_MENU_VIEW] },
    { id: 'user-maintenance-role', path: '/user-maintenance/role', component: <Role />, permissions: [USER_MAINTENANCE_MENU_VIEW] },
    { id: 'user-maintenance-permission', path: '/user-maintenance/permission', component: <Permission />, permissions: [USER_MAINTENANCE_MENU_VIEW] },
    { id: 'user-maintenance-role-permission', path: '/user-maintenance/role-permission', component: <RolePermission />, permissions: [USER_MAINTENANCE_MENU_VIEW] },
    { id: 'user-maintenance-user-manager', path: '/user-maintenance/user-manager', component: <UserManager />, permissions: [USER_MAINTENANCE_MENU_VIEW] },
    { id: 'timeline', path: '/timeline', component: <Timeline /> },
    { id: 'approvals', path: '/Approvals', component: <Approvals /> },
    { id: 'team', path: '/team', component: <Team /> },
    { id: 'notification-bar', path: '/notification-bar', component: <NotificationBar /> },
    { id: 'attendance', path: '/attendance', component: <Attendance />, permissions: [ATTENDANCE_MENU_VIEW] },
    { id: 'my-action', path: '/my-action', component: <MyAction />, permission: null },
    { id: 'reports', path: '/reports', component: <Report />, permissions: [REPORT_MENU_VIEW] },
    { id: 'my-project', path: '/my-project', component: <MyProjectCard /> },
    { id: 'my-project-detail', path: '/my-project-detail', component: <MyProjectDetailCard /> },
    { id: 'travel', path: '/travel', component: <Travels />, permissions: '' },
    { id: 'travelDetails', path: '/TravelDetails', component: <TravelDetails />, permissions: '' },
    { id: 'passportDetails', path: '/PassportDetails', component: <PassportDetails />, permissions: '' },
    { id: 'insuranceDetails', path: '/InsuranceDetails', component: <InsuranceDetails />, permissions: '' },
    // { id: 'travel-preview', path: '/travel-preview', component: <TravelPreview /> },
    { id: 'travel-datatable', path: '/travel-datatable', component: <TravelDataTable /> },
    { id: 'training', path: '/training', component: <TrainingDashboard />, permissions: [TRAINING_MENU_VIEW] },
    { id: 'trf', path: '/trf', component: <Trf />, permissions: '' },
    { id: 'trf-approval', path: '/trf-approval/:id', component: <TrfApproval />, permissions: '' },
    { id: 'training-validation', path: '/training-validation', component: <TrainingValidation /> },
    { id: 'training-effectiveness-feedback', path: '/training-effectiveness-feedback', component: <TrainingEffectivenessFeedback /> },
    { id: 'training-effectiveness-report', path: '/training-effectiveness-report', component: <TrainingEffectivenessReport /> },
    { id: 'forms', path: '/ess-forms', component: <OpenForm /> },
    // { id: 'help', path: '/help', component: <Help /> },
    { id: 'support', path: '/support', component: <Support /> },
    { id: 'support-new-ticket', path: '/support/new-ticket', component: <NewTicket /> },
    { id: 'support-ticket-details', path: '/support/ticket-details/:id', component: <TicketDetails /> },
    { id: 'support-agent-queue', path: '/support-queue', component: <AgentQueue /> },
    { id: 'support-agent-work', path: '/support-agent-work/:id', component: <AgentWork /> },
    { id: 'support-admin', path: '/support-admin', component: <AdminDashboard /> },
]

const AppRoutes = () => {
    const filteredRoutes = getFilteredMenus(routeArray);
    const route = filteredRoutes.map((x) => {
        const item = subRouteArray
            .filter((el) => { return el.parent === x.id })
            .map((e) => { return (<Route key={'r-' + x.id} path={e.path} element={e.component} />) })
        return (
            x.permission === null ? <Route key={'r-' + x.id} path={x.path} element={x.component} /> :
                <Route key={'r-' + x.id} path={x.path} element={x.component} />
        )
    })

    return (
        <div className='view-container'>
            <Routes>
                {route}
                <Route key='nopermission' path="/nopermission" element={<NoPermission />} />
                <Route key='notfound' path="/notfound" element={<PageNotFound />} />
                <Route key='unavailablePath' path="/:unavailablePath" element={<PageNotFound />} />
                <Route key='nf' path="*" element={<PageNotFound />} />
            </Routes>
        </div>
    )
}
export default AppRoutes;